import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router';
import { compose, withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import withLearnosityConfig from 'legacy-src/utility/withLearnosityConfig';
import {
  BluebookContext,
  withBluebookContext,
} from 'chameleon/packages/blue-book-player/state/BluebookContext';
import isEmpty from 'lodash/isEmpty';
import { SET_PLAYER } from 'chameleon/packages/blue-book-player/state/reducer';
import LoadingSpinner from 'chameleon/packages/blue-book-player/LoadingSpinner';
import withBlueBookTeacherPlayer from 'chameleon/src/components/blueBook/hocs/withBlueBookTeacherPlayer';
import withDynamicQuestionsContext from 'chameleon/packages/blue-book-player/hocs/withDynamicQuestionsContext';
import withQbPreviewData from 'chameleon/src/components/blueBook/hocs/withQbPreviewData';
import withPreviewNavigation from 'chameleon/src/components/blueBook/hocs/withPreviewNavigation';
import QuestionDetails from './QuestionDetails';
import withPreviewQuestions from './hocs/withPreviewQuestions';

const TeacherQuestionPlayer = (props) => {
  const { state: playerState, dispatch } = useContext(BluebookContext);

  const {
    learnosityServerData,
    questions,
    allowCalculatorForItems,
    itemId,
    subject,
    learnosityApp,
    userData,
    setAreDetailsExpanded,
    areDetailsExpanded,
  } = props;

  useEffect(() => {
    if (!isEmpty(questions)) {
      dispatch({
        type: SET_PLAYER,
        payload: {
          questions,
          title: '',
          learnositySignedRequest: learnosityServerData,
          allowCalculatorForItems,
          isApcDataLoading: false,
        },
      });
    }
  }, [questions, learnosityServerData, allowCalculatorForItems, dispatch]);

  return !playerState?.isTestReady ? (
    <LoadingSpinner />
  ) : (
    <QuestionDetails
      learnosityServerData={learnosityServerData}
      questions={questions}
      allowCalculatorForItems={allowCalculatorForItems}
      itemId={itemId}
      subject={subject}
      learnosityApp={learnosityApp}
      userData={userData}
      setAreDetailsExpanded={setAreDetailsExpanded}
      areDetailsExpanded={areDetailsExpanded}
    />
  );
};

export default compose(
  withApollo,
  withRouter,
  connect(({ subject: { data }, userData }) => ({
    subject: data,
    userData,
  })),
  withBluebookContext,
  withDynamicQuestionsContext,
  withLearnosityConfig({ isBlueBook: true }),
  withPreviewQuestions,
  withQbPreviewData,
  withPreviewNavigation,
  withBlueBookTeacherPlayer,
)(TeacherQuestionPlayer);
